import { v4 as uuidv4 } from 'uuid';

export const generateV4UUID = () => uuidv4();
export const generateV4UUIDForLayer = () => uuidv4() + '-layer';
